import React, { useState, useEffect, useCallback, useRef } from "react";
import SecureFileImg from './SecureFileImg';
import { openInAppFilePreview } from '../utils/filePreviewBus';
import axios from "axios";
import { FaEye, FaTrash, FaPlus, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight, FaSearch, FaFilter, FaUserCheck, FaDownload, FaEdit } from 'react-icons/fa';
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment/moment";
import FileViewer from "./verifikasi/FileViewer";
import { useSelector } from "react-redux";
import {
  Row,
  Col,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Table,
  Card,
  CardHeader,
  CardBody,
  Badge,
  Spinner,
  Form
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { FaLocationArrow } from "react-icons/fa";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import MyNavbar from "../map/Navbar";
import "./Datarecap.css";
import { kecamatanOptions, kecamatanDesa } from "./verifikasi/constants";
import { useDebouncedTextFilters } from "../hooks/useDebouncedTextFilters";
import CoordinateMapsVerifikasi from "./verifikasi/CoordinateMapsVerifikasi";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const RekapVerifikasi = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { user } = useSelector((state) => state.authAdmin || {});
  const [pdfUrl, setPdfUrl] = useState("");
const [loadingPdf, setLoadingPdf] = useState(false);
const [pdfError, setPdfError] = useState("");
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  
  // Filter state
  const [filters, setFilters] = useState({
    searchName: "",
    searchNik: "",
    searchNoKK: "",
    searchAlamat: "",
    searchstatusKeluarga: "",
    searchstatusVerifikasi: "",
    searchKategori: "",
    kecamatan: "Semua Kecamatan",
    desaKelurahan: "Semua Kelurahan",
    user: ""
  });
  const [isMobile, setIsMobile] = useState(false);
  
  // Modal state
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isMapModalOpen, setIsMapModalOpen] = useState(false);
  const [selectedKecamatan, setSelectedKecamatan] = useState("");
  const [desaKelurahanList, setDesaKelurahanList] = useState([]);
  
  // Edit form state
const [editFormData, setEditFormData] = useState({
  namaKepalaKeluarga: "",
  nik: "",
  nomorKK: "",
  alamat: "",
  kecamatan: "",
  desaKelurahan: "",
  rumahTinggalSendiri: "",
  statusKeluarga: "",
  usiaPernikahan: "",
  StatusKepemilikanTanah: "",
  StatusKepemilikanTanahLainnya: "",
  apakahLokasiTanahSesuaiRTRW: "",
  tingkatPenghasilanKeluarga: "",
  jumlahPenghuniRumah: "",
  score: "",
  kategori: "",
  statusVerifikasi: "",
  verifikasiBantuan: "",
  tanggalVerifikasi: ""
});

// File upload state untuk edit
const [editFileUploads, setEditFileUploads] = useState({
  fotoKK: null,
  fotoRumah: null,
  fotoSuratKepemilikanTanah: null,
  fotoRumahSaatIni: null
});
  
  // Map state
  const [mapCenter, setMapCenter] = useState([-8.5, 116.5]);
  const [mapZoom, setMapZoom] = useState(10);
  
  // Get kecamatan options
  const kecamatanList = ["Semua Kecamatan", ...Object.keys(kecamatanOptions)];
  
  // Status options
  const statusKeluargaOptions = [
    "Semua Status",
    "Sudah Menikah & Kepala Keluarga",
    "Belum Menikah"
  ];
  
  const statusVerifikasiOptions = [
    "Semua Status",
    "Sudah Diverifikasi",
    "Belum Diverifikasi"
  ];

  const statusKategori = [
    "Semua Status",
    "Bisa Dapat Bantuan",
    "Belum Bisa Dapat Bantuan"
  ];

  // Form options for edit modal
  const rumahTinggalSendiriOptions = ["Ya", "Tidak"];
  const statusKeluargaEditOptions = ["Sudah Menikah & Kepala Keluarga", "Belum Menikah"];
  const statusKepemilikanTanahOptions = ["Milik Sendiri,Ada dokumen sah",
  "Milik Sendiri,Tidak ada dokumen",
  "Milik Orang Tua,Ada dokumen sah",
  "Milik Orang Tua,Tidak ada dokumen",
  "Milik Keluarga,Ada dokumen sah",
  "Milik Keluarga,Tidak ada dokumen",
  "Sewa",
  "Hibah",
  "Wakaf",
  "Pinjam",
  "Warisan",
  "Lainnya"];
  const apakahLokasiTanahSesuaiRTRWOptions = ["Sesuai", "Tidak Sesuai"];
  const tingkatPenghasilanKeluargaOptions = ["< 2.5 jt",  "2.5 - 4 jt", "> 4 jt"];
  const statusVerifikasiEditOptions = ["Sudah Diverifikasi","Belum Diverifikasi"];
  const usiaPernikahanOptions = ["> 3", "< 3"]

  const EDIT_FIELD_LABELS = {
    namaKepalaKeluarga: "Nama Kepala Keluarga",
    nik: "NIK",
    nomorKK: "Nomor KK",
    alamat: "Alamat",
    kecamatan: "Kecamatan",
    desaKelurahan: "Desa/Kelurahan",
    rumahTinggalSendiri: "Rumah Tinggal Sendiri",
    statusKeluarga: "Status Keluarga",
    usiaPernikahan: "Usia Pernikahan",
    StatusKepemilikanTanah: "Status Kepemilikan Tanah",
    apakahLokasiTanahSesuaiRTRW: "Lokasi Sesuai RTRW",
    tingkatPenghasilanKeluarga: "Tingkat Penghasilan",
    jumlahPenghuniRumah: "Jumlah Penghuni",
    score: "Score",
    kategori: "Kategori",
    statusVerifikasi: "Status Verifikasi",
    verifikasiBantuan: "Verifikasi Bantuan",
    tanggalVerifikasi: "Tanggal Verifikasi"
  };

  const EDIT_FILE_LABELS = {
    fotoKK: "Foto KK",
    fotoRumah: "Foto Rumah",
    fotoSuratKepemilikanTanah: "Foto Surat Kepemilikan Tanah",
    fotoRumahSaatIni: "Foto Rumah Saat Ini"
  };

  const fetchIdRef = useRef(0);
  const abortControllerRef = useRef(null);
  const queryFilters = useDebouncedTextFilters(
    filters,
    ["searchName", "searchNik", "searchNoKK", "searchAlamat"]
  );

  const fetchData = useCallback(async ({ activeFilters = queryFilters, page = currentPage } = {}) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;
    const fetchId = ++fetchIdRef.current;

    setLoading(true);
    setError("");
    
    try {
      const trimmedSearchName = activeFilters.searchName?.trim();
      const trimmedSearchNik = activeFilters.searchNik?.trim();
      const trimmedSearchNoKK = activeFilters.searchNoKK?.trim();
      const trimmedSearchAlamat = activeFilters.searchAlamat?.trim();
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trimmedSearchName && { searchName: trimmedSearchName }),
        ...(trimmedSearchNik && { searchNik: trimmedSearchNik }),
        ...(trimmedSearchNoKK && { searchNoKK: trimmedSearchNoKK }),
        ...(trimmedSearchAlamat && { searchAlamat: trimmedSearchAlamat }),
        ...(activeFilters.searchstatusKeluarga && activeFilters.searchstatusKeluarga !== "Semua Status" && { searchstatusKeluarga: activeFilters.searchstatusKeluarga }),
        ...(activeFilters.searchstatusVerifikasi && activeFilters.searchstatusVerifikasi !== "Semua Status" && { searchstatusVerifikasi: activeFilters.searchstatusVerifikasi }),
        ...(activeFilters.searchKategori && activeFilters.searchKategori !== "Semua Status" && { searchKategori: activeFilters.searchKategori }),
        ...(activeFilters.kecamatan && activeFilters.kecamatan !== "Semua Kecamatan" && { searchKecamatan: activeFilters.kecamatan }),
        ...(activeFilters.desaKelurahan && activeFilters.desaKelurahan !== "Semua Kelurahan" && { searchDesaKelurahan: activeFilters.desaKelurahan }),
        ...(activeFilters.user && { user: activeFilters.user })
      });

      const response = await axios.get(`${process.env.REACT_APP_URL}/getverifikasi?${params}`, {
        withCredentials: true,
        signal: controller.signal,
      });

      if (fetchId !== fetchIdRef.current) return;

      if (response.status === 200) {
        setData(response.data.data || []);
        setTotalPages(response.data.pagination?.totalPages || 1);
        setTotalItems(response.data.pagination?.totalItems || 0);
      }
    } catch (error) {
      if (error.code === "ERR_CANCELED" || error.name === "CanceledError") return;
      if (fetchId !== fetchIdRef.current) return;
      console.error("Error fetching data:", error);
      setError("Gagal memuat data verifikasi");
    } finally {
      if (fetchId === fetchIdRef.current) {
        setLoading(false);
      }
    }
  }, [currentPage, limit, queryFilters]);

  // Fetch data when component mounts or filters change
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Handle filter changes
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchData({ activeFilters: filters, page: 1 });
  };

  // Handle reset filters
  const handleResetFilters = () => {
    setFilters({
      searchName: "",
      searchNik: "",
      searchNoKK: "",
      searchAlamat: "",
      searchstatusKeluarga: "",
      searchstatusVerifikasi: "",
      searchKategori: "",
      kecamatan: "Semua Kecamatan",
      desaKelurahan:"Semua Kelurahan",
      user: ""
    });
    setCurrentPage(1);
  };

  // Handle pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // Handle view details
  const handleView = (item) => {
    setSelectedItem(item);
    setIsViewModalOpen(true);
  };

  // Handle edit
const handleEdit = (item) => {
  setSelectedItem(item);
  
  // Cek apakah StatusKepemilikanTanah ada di array options
  const isInOptions = statusKepemilikanTanahOptions.includes(item.StatusKepemilikanTanah);
  const isLainnya = item.StatusKepemilikanTanah === "Lainnya";
  
  // Jika tidak ada di options dan bukan "Lainnya", berarti ini nilai manual
  // Simpan nilai manual ke StatusKepemilikanTanahLainnya dan set StatusKepemilikanTanah ke "Lainnya"
  let statusKepemilikanTanah = item.StatusKepemilikanTanah || "";
  let statusKepemilikanTanahLainnya = "";
  
  if (!isInOptions && !isLainnya && item.StatusKepemilikanTanah) {
    // Nilai manual yang tidak ada di array
    statusKepemilikanTanahLainnya = item.StatusKepemilikanTanah;
    statusKepemilikanTanah = "Lainnya";
  } else if (isLainnya && item.StatusKepemilikanTanahLainnya) {
    // Jika sudah "Lainnya", ambil nilai dari field lainnya
    statusKepemilikanTanahLainnya = item.StatusKepemilikanTanahLainnya;
  }
  
  setEditFormData({
    namaKepalaKeluarga: item.namaKepalaKeluarga || "",
    nik: item.nik || "",
    nomorKK: item.nomorKK || "",
    alamat: item.alamat || "",
    kecamatan: item.kecamatan || "",
    desaKelurahan: item.desaKelurahan || "",
    rumahTinggalSendiri: item.rumahTinggalSendiri || "",
    statusKeluarga: item.statusKeluarga || "",
    usiaPernikahan: item.statusKeluarga === "Sudah Menikah & Kepala Keluarga" ? (item.usiaPernikahan || "") : "",
    StatusKepemilikanTanah: statusKepemilikanTanah,
    StatusKepemilikanTanahLainnya: statusKepemilikanTanahLainnya,
    apakahLokasiTanahSesuaiRTRW: item.apakahLokasiTanahSesuaiRTRW || "",
    tingkatPenghasilanKeluarga: item.tingkatPenghasilanKeluarga || "",
    jumlahPenghuniRumah: item.jumlahPenghuniRumah || "",
    score: item.score || "",
    kategori: item.kategori || "",
    statusVerifikasi: item.statusVerifikasi || "",
    verifikasiBantuan: item.verifikasiBantuan || "",
    tanggalVerifikasi: item.tanggalVerifikasi || ""
  });
  // Reset file uploads ketika modal dibuka
  setEditFileUploads({
    fotoKK: null,
    fotoRumah: null,
    fotoSuratKepemilikanTanah: null,
    fotoRumahSaatIni: null
  });
  setIsEditModalOpen(true);
};

  // Handle edit form change
  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    
    // Jika StatusKepemilikanTanah berubah, reset StatusKepemilikanTanahLainnya jika bukan "Lainnya"
    if (name === "StatusKepemilikanTanah") {
      setEditFormData(prev => ({
        ...prev,
        StatusKepemilikanTanah: value,
        ...(value !== "Lainnya" ? { StatusKepemilikanTanahLainnya: "" } : {})
      }));
      if (value !== "Milik Sendiri,Ada dokumen sah") {
        setEditFileUploads(prev => ({ ...prev, fotoSuratKepemilikanTanah: null }));
      }
    } else if (name === "statusKeluarga") {
      // Reset usia pernikahan jika status keluarga bukan "Sudah Menikah & Kepala Keluarga"
      setEditFormData(prev => ({
        ...prev,
        statusKeluarga: value,
        ...(value !== "Sudah Menikah & Kepala Keluarga" ? { usiaPernikahan: "" } : {})
      }));
    } else {
      setEditFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Handle file upload untuk edit modal
  const handleEditFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    
    if (file) {
      setEditFileUploads(prev => ({
        ...prev,
        [name]: file
      }));
    }
  };

// Kumpulkan perubahan (sebelum vs sesudah) untuk pratinjau sebelum simpan
const getEditChanges = () => {
  if (!selectedItem) return [];
  const changes = [];

  Object.keys(EDIT_FIELD_LABELS).forEach((key) => {
    if (key === "usiaPernikahan" && editFormData.statusKeluarga !== "Sudah Menikah & Kepala Keluarga") {
      return;
    }
    let before = selectedItem[key] ?? "";
    let after = editFormData[key] ?? "";
    if (key === "StatusKepemilikanTanah") {
      before = selectedItem.StatusKepemilikanTanah || "";
      after = editFormData.StatusKepemilikanTanah === "Lainnya"
        ? (editFormData.StatusKepemilikanTanahLainnya || "")
        : (editFormData.StatusKepemilikanTanah || "");
    }
    if (String(before).trim() !== String(after).trim()) {
      changes.push({
        label: EDIT_FIELD_LABELS[key],
        before,
        after
      });
    }
  });

  const fileOriginalField = {
    fotoKK: "fotoKK",
    fotoRumah: "foto",
    fotoSuratKepemilikanTanah: "fotoSuratKepemilikanTanah",
    fotoRumahSaatIni: "fotoRumahSaatIni"
  };
  Object.keys(EDIT_FILE_LABELS).forEach((key) => {
    if (editFileUploads[key]) {
      changes.push({
        label: EDIT_FILE_LABELS[key],
        before: selectedItem[fileOriginalField[key]] ? "File lama" : "-",
        after: `File baru: ${editFileUploads[key].name}`
      });
    }
  });

  return changes;
};

// Handle edit form submit
const handleEditSubmit = async (e) => {
  e.preventDefault();

  // Siapkan form data dengan file uploads
  const formData = new FormData();
  
  // Tambah field data
  Object.keys(editFormData).forEach(key => {
    formData.append(key, editFormData[key]);
  });

  // Tambah file uploads jika ada
  Object.keys(editFileUploads).forEach(key => {
    if (editFileUploads[key]) {
      formData.append(key, editFileUploads[key]);
    }
  });

  // Jika StatusKepemilikanTanah adalah "Lainnya", gunakan nilai dari StatusKepemilikanTanahLainnya
  const statusValue = editFormData.StatusKepemilikanTanah;
  if (statusValue === "Lainnya" && editFormData.StatusKepemilikanTanahLainnya) {
    formData.set("StatusKepemilikanTanah", editFormData.StatusKepemilikanTanahLainnya);
  }
  
  // Hapus field StatusKepemilikanTanahLainnya dari form data
  formData.delete("StatusKepemilikanTanahLainnya");

  console.log("Data yang dikirim ke server (dengan files)");

  try {
    const response = await axios.put(
      `${process.env.REACT_APP_URL}/updateverifikasi/${selectedItem.id}`,
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (response.status === 200) {
      setSuccess("Data berhasil diperbarui");
      fetchData();
      setIsEditModalOpen(false);
      setSelectedItem(null);
      setEditFileUploads({
        fotoKK: null,
        fotoRumah: null,
        fotoSuratKepemilikanTanah: null,
        fotoRumahSaatIni: null
      });

      // Clear success message after 3 seconds
      setTimeout(() => setSuccess(""), 3000);
    }
  } catch (error) {
    console.error("Error updating data:", error);
    setError(error.response?.data?.message || "Gagal memperbarui data");

    // Clear error message after 3 seconds
    setTimeout(() => setError(""), 3000);
  }
};


  // Handle verification
  const handleVerifikasi = (item) => {
    setSelectedItem(item);
    setIsVerificationModalOpen(true);
  };

  // Confirm verification
  const verifikasiBantuan = async () => {
    try {  
      const response = await axios.put(`${process.env.REACT_APP_URL}/updateverifikasibantuanpb/${selectedItem.id}`, {}, {
        withCredentials: true,
      });
      
      if (response.status === 200) {
        setSuccess("Data berhasil divalidasi sebagai 'Sudah Dapat Bantuan'");
        fetchData();
        setIsVerificationModalOpen(false);
        setSelectedItem(null);
        
        // Clear success message after 3 seconds
        setTimeout(() => setSuccess(""), 3000);
      }
    } catch (error) {
      console.error("Error verifying data:", error);
      setError(error.response?.data?.message || "Gagal memverifikasi data");
      
      // Clear error message after 3 seconds
      setTimeout(() => setError(""), 3000);
    }
  };

  // Handle delete
  const handleDelete = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  // Confirm delete
  const confirmDelete = async () => {
    if (!selectedItem) return;
    
    try {
      const response = await axios.delete(`${process.env.REACT_APP_URL}/deleteverifikasi/${selectedItem.id}`, {
        withCredentials: true,
      });

      if (response.status === 200) {
        setSuccess("Data berhasil dihapus");
        fetchData();
        setIsDeleteModalOpen(false);
        setSelectedItem(null);
        
        // Clear success message after 3 seconds
        setTimeout(() => setSuccess(""), 3000);
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      setError("Gagal menghapus data");
      
      // Clear error message after 3 seconds
      setTimeout(() => setError(""), 3000);
    }
  };

  // Handle view on map
  const handleViewOnMap = (item) => {
    if (item.titikKoordinatRumah) {
      const [lat, lng] = item.titikKoordinatRumah.split(',').map(coord => parseFloat(coord.trim()));
      setMapCenter([lat, lng]);
      setMapZoom(15);
      setSelectedItem(item);
      setIsMapModalOpen(true);
    } else {
      setError("Koordinat tidak tersedia");
      setTimeout(() => setError(""), 3000);
    }
  };

  // Get status badge color
  const getStatusBadgeColor = (status) => {
    switch (status) {
      case "Sudah Diverifikasi":
        return "success";
      case "Belum Diverifikasi":
        return "warning";
      default:
        return "secondary";
    }
  };
  
  const getCategoryBadgeColor = (kategori) => {
    switch (kategori) {
      case "Bisa Dapat Bantuan":
        return "success";
      case "Belum Bisa Dapat Bantuan":
        return "danger";
      default:
        return "secondary";
    }
  };

  // Helper function untuk render file preview
  const renderFilePreview = (filePath, fileName) => {
    if (!filePath) return null;

    const fileUrl = `${process.env.REACT_APP_URL}/${filePath}`;
    const isImage = /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath);
    const isPdf = /\.pdf$/i.test(filePath);

    return (
      <div className="mb-3 p-3 bg-light rounded border">
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-grow-1">
            <h6 className="mb-2">
              <i className="fas fa-check-circle text-success me-2"></i>
              File Saat Ini: {fileName}
            </h6>
            {isImage ? (
              <SecureFileImg
                src={fileUrl}
                alt={fileName}
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '4px',
                  objectFit: 'cover',
                  marginBottom: '10px'
                }}
              />
            ) : isPdf ? (
              <div className="mb-2">
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openInAppFilePreview({ url: fileUrl })}>
                  <i className="fas fa-file-pdf me-1"></i> Lihat PDF
                </button>
              </div>
            ) : (
              <div className="mb-2">
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => openInAppFilePreview({ url: fileUrl })}>
                  <i className="fas fa-download me-1"></i> Download
                </button>
              </div>
            )}
          </div>
        </div>
        <small className="text-muted d-block mt-2">Upload file baru untuk mengganti file ini</small>
      </div>
    );
  };
  
  const handleExportExcel = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/exportexcelverifikasi`,
        {
          params: { kecamatan: selectedKecamatan },
          responseType: "blob", 
          withCredentials: true,
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "verifikasi.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      setError("Gagal mengunduh data. Pastikan Anda memilih kecamatan yang benar.");
      setTimeout(() => setError(""), 3000);
    }
  };

  // Render pagination
  const renderPagination = () => {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Button
          key={i}
          color={i === currentPage ? "primary" : "outline-primary"}
          size="sm"
          onClick={() => handlePageChange(i)}
          className="mx-1"
        >
          {i}
        </Button>
      );
    }

    return (
      <div className="d-flex justify-content-center align-items-center mt-3">
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="mx-1"
        >
          <FaAngleDoubleLeft />
        </Button>
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="mx-1"
        >
          <FaAngleLeft />
        </Button>
        {pages}
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="mx-1"
        >
          <FaAngleRight />
        </Button>
        <Button
          color="outline-primary"
          size="sm"
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="mx-1"
        >
          <FaAngleDoubleRight />
        </Button>
      </div>
    );
  };
  
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Update desa/kelurahan list ketika kecamatan filter berubah
  useEffect(() => {
    if (filters.kecamatan && filters.kecamatan !== "Semua Kecamatan") {
      const desaList = kecamatanDesa[filters.kecamatan] || [];
      setDesaKelurahanList(["Semua Kelurahan", ...desaList]);
      // Reset desaKelurahan filter jika kecamatan berubah
      setFilters(prev => ({
        ...prev,
        desaKelurahan: "Semua Kelurahan"
      }));
    } else {
      setDesaKelurahanList([]);
      setFilters(prev => ({
        ...prev,
        desaKelurahan: "Semua Kelurahan"
      }));
    }
  }, [filters.kecamatan]);
  
  const contentStyle = isMobile 
    ? {} // No margins on mobile
    : { marginLeft: "250px", marginRight: "20px" };
    
  const editChanges = getEditChanges();
  const isEditMarried = editFormData.statusKeluarga === "Sudah Menikah & Kepala Keluarga";
  const isEditMilikSendiri = editFormData.StatusKepemilikanTanah === "Milik Sendiri,Ada dokumen sah";
    
  return (
    <div className="data-content-wrapper">
      <div className="main-content" style={contentStyle}>
        <div className="col-12">
          <Card className="mt-3">
            <CardHeader>
              <h4 className="mb-0">Rekap Data Verifikasi Bangun Baru</h4>
            </CardHeader>
            <CardBody>
              {/* Filters */}
              <Row className="mb-4">
                <Col md={3}>
                  <FormGroup>
                    <Label for="searchName">Cari Nama</Label>
                    <Input
                      type="text"
                      name="searchName"
                      id="searchName"
                      value={filters.searchName}
                      onChange={handleFilterChange}
                      placeholder="Masukkan nama kepala keluarga"
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="searchNik">Cari NIK</Label>
                    <Input
                      type="text"
                      name="searchNik"
                      id="searchNik"
                      value={filters.searchNik}
                      onChange={handleFilterChange}
                      placeholder="Masukkan NIK"
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="searchNoKK">Cari No KK</Label>
                    <Input
                      type="text"
                      name="searchNoKK"
                      id="searchNoKK"
                      value={filters.searchNoKK}
                      onChange={handleFilterChange}
                      placeholder="Masukkan Nomor KK"
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup>
                    <Label for="searchAlamat">Cari Alamat</Label>
                    <Input
                      type="text"
                      name="searchAlamat"
                      id="searchAlamat"
                      value={filters.searchAlamat}
                      onChange={handleFilterChange}
                      placeholder="Masukkan alamat"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="kecamatan">Kecamatan</Label>
                    <Input
                      type="select"
                      name="kecamatan"
                      id="kecamatan"
                      value={filters.kecamatan}
                      onChange={handleFilterChange}
                    >
                      {kecamatanList.map(kec => (
                        <option key={kec} value={kec}>{kec}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="desaKelurahan">Desa/Kelurahan</Label>
                    <Input
                      type="select"
                      name="desaKelurahan"
                      id="desaKelurahan"
                      value={filters.desaKelurahan}
                      onChange={handleFilterChange}
                      disabled={filters.kecamatan === "Semua Kecamatan"}
                    >
                      {desaKelurahanList.length > 0 
                        ? desaKelurahanList.map(desa => (
                            <option key={desa} value={desa}>{desa}</option>
                          ))
                        : <option value="Semua Kelurahan">Semua Kelurahan</option>
                      }
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="searchstatusKeluarga">Status Keluarga</Label>
                    <Input
                      type="select"
                      name="searchstatusKeluarga"
                      id="searchstatusKeluarga"
                      value={filters.searchstatusKeluarga}
                      onChange={handleFilterChange}
                    >
                      {statusKeluargaOptions.map(status => (
                        <option key={status} value={status}>{status}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label for="searchKategori">Status Kategori</Label>
                    <Input
                      type="select"
                      name="searchKategori"
                      id="searchKategori"
                      value={filters.searchKategori}
                      onChange={handleFilterChange}
                    >
                      {statusKategori.map(status => (
                        <option key={status} value={status}>{status}</option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md={4} className="d-flex align-items-end">
                  <div>
                    <Button color="primary" onClick={handleSearch} className="me-2">
                      <FaSearch className="me-1" />
                      Cari
                    </Button>
                    <Button color="secondary" onClick={handleResetFilters}>
                      <FaFilter className="me-1" />
                      Reset
                    </Button>
                  </div>
                </Col>
                {/* <Col md={6} className="d-flex align-items-end justify-content-end">
                  <div>
                    <Button color="success" onClick={() => navigate("/verifikasi")} className="me-2">
                      <FaPlus className="me-1" />
                      Tambah Verifikasi
                    </Button>
                  </div>
                </Col> */}
                   {user && user.role === "admin" && (
              <Col md={6}>
                <div className="p-3 bg-light rounded border">
                  <h5 className="mb-3">Export Data</h5>
                  <div className="form-group mb-3">
                    <label htmlFor="exportKecamatan" className="form-label fw-bold">Pilih Kecamatan:</label>
                    <select
                      id="exportKecamatan"
                      className="form-select mb-3"
                      value={selectedKecamatan}
                      onChange={(e) => setSelectedKecamatan(e.target.value)}
                    >
                      <option value="">Semua Kecamatan</option>
                      <option value="Taliwang">Taliwang</option>
                      <option value="Seteluk">Seteluk</option>
                      <option value="Poto Tano">Poto Tano</option>
                      <option value="Brang Rea">Brang Rea</option>
                      <option value="Brang Ene">Brang Ene</option>
                      <option value="Jereweh">Jereweh</option>
                      <option value="Maluk">Maluk</option>
                      <option value="Sekongkang">Sekongkang</option>
                    </select>
                    <Button
                      color="primary"
                      onClick={handleExportExcel}
                      style={{
                        borderRadius: "6px",
                        backgroundImage: "linear-gradient(135deg, #1abc9c, #3498db)",
                        border: "none",
                        width: "100%",
                      }}
                    >
                      Export to Excel
                    </Button>
                  </div>
                </div>
              </Col>
              )}
              </Row>
             

              {/* Alerts */}
              {error && <Alert color="danger">{error}</Alert>}
              {success && <Alert color="success">{success}</Alert>}

              {/* Data Table */}
              <div className="table-responsive">
                <Table striped hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Nama KK</th>
                      <th>NIK</th>
                      <th>Alamat</th>
                      <th>Kecamatan</th>
                      <th>Desa/Kelurahan</th>
                      <th>Status Keluarga</th>
                      <th>Bantuan PB</th>
                      <th>Score</th>
                      <th>Kategori</th>
                      <th>Tgl. Verifikasi</th>
                      <th>Tgl. Bantuan</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="13" className="text-center">
                          <Spinner size="sm" color="primary" />
                          <span className="ms-2">Memuat data...</span>
                        </td>
                      </tr>
                    ) : data.length === 0 ? (
                      <tr>
                        <td colSpan="13" className="text-center">Tidak ada data</td>
                      </tr>
                    ) : (
                      data.map((item, index) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * limit + index + 1}</td>
                          <td>{item.namaKepalaKeluarga}</td>
                          <td>{item.nik}</td>
                          <td>{item.alamat}</td>
                          <td>{item.kecamatan}</td>
                          <td>{item.desaKelurahan}</td>
                          <td>{item.statusKeluarga}</td>
                          <td>
                            <Badge color={item.verifikasiBantuan === "Sudah Dapat Bantuan" ? "success" : "warning"}>
                              {item.verifikasiBantuan}
                            </Badge>
                          </td>
                          <td>
                            <Badge color={item.score >= 70 ? "success" : "warning"}>
                              {item.score}
                            </Badge>
                          </td>
                          <td>
                            <Badge color={getCategoryBadgeColor(item.kategori)}>
                              {item.kategori}
                            </Badge>
                          </td>
                          <td>{moment(item.tanggalVerifikasi).format("DD/MM/YYYY")}</td>
                          <td>
                            {item.Bantuans && item.Bantuans.length > 0
                              ? moment(item.Bantuans[0].tanggalBantuan).format("DD/MM/YYYY")
                              : '-'}
                          </td>
                           <td className="text-center">
                      <div className="d-flex justify-content-center align-items-center gap-2">
                              <div>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() => handleView(item)}
                               className="p-0 me-2"
                                title="Lihat Detail"
                              >
                                <FaEye />
                              </Button>
                              </div>
                               <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => handleEdit(item)}
                                  className="me-1"
                                  title="Edit Data"
                                >
                                  <FaEdit />
                                </Button>
                              {/* Edit Button - Available for admin and data owner */}
                              {/* {(user && (user.role === "admin" || item.adminId === user.id)) && (
                                <Button
                                  color="warning"
                                  size="sm"
                                  onClick={() => handleEdit(item)}
                                  className="me-1"
                                  title="Edit Data"
                                >
                                  <FaEdit />
                                </Button>
                              )} */}
                              
                              {user && user.role === "admin" && (
                                <>
                               
                                  <div className="d-flex justify-content-center align-items-center gap-2">
                                  <Button
                                    color="success"
                                    size="sm"
                                    onClick={() => handleVerifikasi(item)}
                                   className="p-0 me-2"
                                    title="Validasi Bantuan"
                                  >
                                    <FaUserCheck />
                                  </Button>
                                  </div>
                                   <div className="d-flex justify-content-center align-items-center">
                                  <Button
                                   // color="danger"
                                    size="sm"
                                    onClick={() => handleDelete(item)}
                                   className="p-0 me-2"
                                    title="Hapus Data"
                                  >
                                    <FaTrash />
                                  </Button>
                                  </div>
                                </>
                              )}
                              <div className="btn-group" role="group">
                              {item.titikKoordinatRumah && (
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => handleViewOnMap(item)}
                                  title="Lihat di Peta"
                                >
                                  <FaLocationArrow />
                                </Button>
                              )}
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Pagination Info */}
              <Row className="mt-3">
                <Col md={2}>
                  <FormGroup>
                    <Label for="limit">Items per page</Label>
                    <Input
                      type="select"
                      name="limit"
                      id="limit"
                      value={limit}
                      onChange={handleLimitChange}
                    >
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <p className="text-muted">
                    Menampilkan {((currentPage - 1) * limit) + 1} sampai {Math.min(currentPage * limit, totalItems)} dari {totalItems} data
                  </p>
                </Col>
                <Col md={6}>
                  {renderPagination()}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>

      {/* View Modal */}
      <Modal isOpen={isViewModalOpen} toggle={() => setIsViewModalOpen(false)} size="lg" style={{ maxWidth: '900px' }}>
        <ModalHeader toggle={() => setIsViewModalOpen(false)}>
          Detail Verifikasi - {selectedItem?.namaKepalaKeluarga}
        </ModalHeader>
        <ModalBody>
          {selectedItem && (
            <div>
              {/* SECTION 1: Data Pribadi & Lokasi */}
              <h6 className="text-primary mb-3"><i className="fas fa-user me-2"></i>Data Pribadi & Lokasi</h6>
              <Table size="sm" bordered responsive className="align-middle mb-4">
                <tbody>
                  <tr><td className="text-muted label-cell">Nama Kepala Keluarga</td><td>{selectedItem.namaKepalaKeluarga}</td></tr>
                  <tr><td className="text-muted label-cell">NIK</td><td>{selectedItem.nik}</td></tr>
                  <tr><td className="text-muted label-cell">No. KK</td><td>{selectedItem.nomorKK}</td></tr>
                  <tr><td className="text-muted label-cell">Alamat</td><td>{selectedItem.alamat}</td></tr>
                  <tr><td className="text-muted label-cell">Kecamatan</td><td>{selectedItem.kecamatan}</td></tr>
                  <tr><td className="text-muted label-cell">Desa/Kelurahan</td><td>{selectedItem.desaKelurahan}</td></tr>
                  <tr><td className="text-muted label-cell">Koordinat</td><td>{selectedItem.titikKoordinatRumah || 'Koordinat tidak tersedia'}</td></tr>
                </tbody>
              </Table>

              {/* SECTION 2: Status Rumah & Keluarga */}
              <h6 className="text-primary mb-3"><i className="fas fa-home me-2"></i>Status Rumah & Keluarga</h6>
              <Table size="sm" bordered responsive className="align-middle mb-4">
                <tbody>
                  <tr><td className="text-muted label-cell">Rumah Tinggal Sendiri</td><td>{selectedItem.rumahTinggalSendiri}</td></tr>
                  <tr><td className="text-muted label-cell">Status Keluarga</td><td>{selectedItem.statusKeluarga}</td></tr>
                  <tr><td className="text-muted label-cell">Usia Pernikahan</td><td>{selectedItem.usiaPernikahan} tahun</td></tr>
                  <tr><td className="text-muted label-cell">Jumlah Penghuni</td><td>{selectedItem.jumlahPenghuniRumah} orang</td></tr>
                  <tr><td className="text-muted label-cell">Status Kepemilikan Tanah</td><td>{selectedItem.StatusKepemilikanTanah}</td></tr>
                  <tr><td className="text-muted label-cell">Lokasi Sesuai RTRW</td><td>{selectedItem.apakahLokasiTanahSesuaiRTRW}</td></tr>
                  <tr><td className="text-muted label-cell">Tingkat Penghasilan</td><td>{selectedItem.tingkatPenghasilanKeluarga}</td></tr>
                </tbody>
              </Table>

              {/* SECTION 3: Skor & Status */}
              <h6 className="text-primary mb-3"><i className="fas fa-file-alt me-2"></i>Skor & Status</h6>
              <div className="row text-center g-2 mb-4">
                <div className="col-6 col-md-3 mb-2">
                  <div className="border rounded p-2 h-100">
                    <small className="text-muted d-block">Score</small>
                    <span className={`fs-5 ${selectedItem.score >= 70 ? 'text-success' : 'text-warning'}`}>{selectedItem.score}</span>
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-2">
                  <div className="border rounded p-2 h-100">
                    <small className="text-muted d-block">Kategori</small>
                    <Badge color={getCategoryBadgeColor(selectedItem.kategori)}>{selectedItem.kategori}</Badge>
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-2">
                  <div className="border rounded p-2 h-100">
                    <small className="text-muted d-block">Status Validasi</small>
                    <Badge color={getStatusBadgeColor(selectedItem.statusVerifikasi)}>{selectedItem.statusVerifikasi}</Badge>
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-2">
                  <div className="border rounded p-2 h-100">
                    <small className="text-muted d-block">Bantuan PB</small>
                    <Badge color={selectedItem.verifikasiBantuan === "Sudah Dapat Bantuan" ? "success" : "warning"}>{selectedItem.verifikasiBantuan}</Badge>
                  </div>
                </div>
              </div>

              {/* SECTION 4: Catatan */}
              <h6 className="text-primary mb-3"><i className="fas fa-sticky-note me-2"></i>Catatan</h6>
              <div className="border rounded p-3 bg-light mb-4" style={{ whiteSpace: 'pre-wrap' }}>
                {selectedItem.catatan || 'Tidak ada catatan'}
              </div>

              {/* SECTION 5: Dokumentasi */}
              <h6 className="text-primary mb-3"><i className="fas fa-images me-2"></i>Dokumentasi</h6>
              <div className="row mb-3">
                <div className="col-6 col-md-3 mb-3">
                  <div className="card border-0 bg-light p-2 text-center">
                    <small className="text-muted d-block mb-1">Foto KK</small>
                    {selectedItem.fotoKK ? (
                      <img
                        src={`${process.env.REACT_APP_URL}/${selectedItem.fotoKK}`}
                        alt="Foto KK"
                        className="img-thumbnail"
                        style={{ maxHeight: '150px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="text-muted">Tidak ada</div>
                    )}
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-3">
                  <div className="card border-0 bg-light p-2 text-center">
                    <small className="text-muted d-block mb-1">Foto Rumah</small>
                    {selectedItem.foto ? (
                      <img
                        src={`${process.env.REACT_APP_URL}/${selectedItem.foto}`}
                        alt="Foto Rumah"
                        className="img-thumbnail"
                        style={{ maxHeight: '150px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="text-muted">Tidak ada</div>
                    )}
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-3">
                  <div className="card border-0 bg-light p-2 text-center">
                    <small className="text-muted d-block mb-1">Foto Surat Tanah</small>
                    {selectedItem.fotoSuratKepemilikanTanah ? (
                      <img
                        src={`${process.env.REACT_APP_URL}/${selectedItem.fotoSuratKepemilikanTanah}`}
                        alt="Foto Surat Tanah"
                        className="img-thumbnail"
                        style={{ maxHeight: '150px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="text-muted">Tidak ada</div>
                    )}
                  </div>
                </div>
                <div className="col-6 col-md-3 mb-3">
                  <div className="card border-0 bg-light p-2 text-center">
                    <small className="text-muted d-block mb-1">Foto Rumah Saat Ini</small>
                    {selectedItem.fotoRumahSaatIni ? (
                      <img
                        src={`${process.env.REACT_APP_URL}/${selectedItem.fotoRumahSaatIni}`}
                        alt="Foto Rumah Saat Ini"
                        className="img-thumbnail"
                        style={{ maxHeight: '150px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="text-muted">Tidak ada</div>
                    )}
                  </div>
                </div>
              </div>

              {/* SECTION 6: Peta Lokasi */}
              <h6 className="text-primary mb-2"><i className="fas fa-map me-2"></i>Peta Lokasi</h6>
              <div className="mb-3">
                <CoordinateMapsVerifikasi coordinates={selectedItem.titikKoordinatRumah} />
              </div>

              {/* SECTION 7: Informasi Tambahan */}
              <h6 className="text-primary mb-3"><i className="fas fa-clock me-2"></i>Informasi Tambahan</h6>
              <Table size="sm" bordered responsive className="align-middle mb-0">
                <tbody>
                  <tr><td className="text-muted label-cell">Tanggal Verifikasi</td><td>{moment(selectedItem.tanggalVerifikasi).format('DD MMMM YYYY')}</td></tr>
                  <tr><td className="text-muted label-cell">Divalidasi oleh</td><td>{selectedItem.Admin?.username || '-'}</td></tr>
                </tbody>
              </Table>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsViewModalOpen(false)}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>

      {/* Edit Modal */}
      <Modal isOpen={isEditModalOpen} toggle={() => setIsEditModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setIsEditModalOpen(false)}>
          Edit Data Validasi - {selectedItem?.namaKepalaKeluarga}
        </ModalHeader>
        <Form onSubmit={handleEditSubmit}>
          <ModalBody>
            <div className="border rounded p-3 bg-light mb-3">
              <h6 className="text-primary mb-2"><i className="fas fa-exchange-alt me-2"></i>Perubahan Data</h6>
              {editChanges.length === 0 ? (
                <small className="text-muted">Belum ada perubahan</small>
              ) : (
                <Table size="sm" bordered responsive className="align-middle mb-0">
                  <thead>
                    <tr>
                      <th className="fw-normal text-muted">Field</th>
                      <th className="fw-normal text-muted">Sebelum</th>
                      <th className="fw-normal text-muted">Menjadi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {editChanges.map((c, i) => (
                      <tr key={i}>
                        <td className="text-muted label-cell">{c.label}</td>
                        <td>{c.before === "" ? "-" : c.before}</td>
                        <td>{c.after === "" ? "-" : c.after}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
            <Row>
              <Col md={6}>
              <FormGroup>
                
  <Label for="editNamaKK">Nama Kepala Keluarga</Label>
  <Input
    type="text"
    name="namaKepalaKeluarga"
    id="editNamaKK"
    value={editFormData.namaKepalaKeluarga}
    onChange={handleEditFormChange}
    required
  />
</FormGroup>

<FormGroup>
  <Label for="editAlamat">Alamat</Label>
  <Input
    type="text"
    name="alamat"
    id="editAlamat"
    value={editFormData.alamat}
    onChange={handleEditFormChange}
    required
  />
</FormGroup>
<FormGroup>
                  <Label for="editNomorKK">Nomor KK</Label>
                  <Input
                    type="text"
                    name="nomorKK"
                    id="editNomorKK"
                    value={editFormData.nomorKK}
                    onChange={handleEditFormChange}
                    required
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="editNik">NIK</Label>
                  <Input
                    type="text"
                    name="nik"
                    id="editNik"
                    value={editFormData.nik}
                    onChange={handleEditFormChange}
                    required
                  />
                </FormGroup>
                
                <FormGroup>
                  <Label for="editKecamatan">Kecamatan</Label>
                  <Input
                    type="select"
                    name="kecamatan"
                    id="editKecamatan"
                    value={editFormData.kecamatan}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Kecamatan</option>
                    {Object.keys(kecamatanOptions).map(kec => (
                      <option key={kec} value={kec}>{kec}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editDesaKelurahan">Desa/Kelurahan</Label>
                  <Input
                    type="select"
                    name="desaKelurahan"
                    id="editDesaKelurahan"
                    value={editFormData.desaKelurahan}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Desa/Kelurahan</option>
                    {editFormData.kecamatan && kecamatanOptions[editFormData.kecamatan]?.map(desa => (
                      <option key={desa} value={desa}>{desa}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editRumahTinggalSendiri">Rumah Tinggal Sendiri</Label>
                  <Input
                    type="select"
                    name="rumahTinggalSendiri"
                    id="editRumahTinggalSendiri"
                    value={editFormData.rumahTinggalSendiri}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Status</option>
                    {rumahTinggalSendiriOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editStatusKeluarga">Status Keluarga</Label>
                  <Input
                    type="select"
                    name="statusKeluarga"
                    id="editStatusKeluarga"
                    value={editFormData.statusKeluarga}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Status</option>
                    {statusKeluargaEditOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editUsiaPernikahan">
                    Usia Pernikahan
                    {isEditMarried && <span className="text-danger"> *</span>}
                    {!isEditMarried && <span className="text-muted"> (Tidak berlaku)</span>}
                  </Label>
                  <Input
                    type="select"
                    name="usiaPernikahan"
                    id="editUsiaPernikahan"
                    value={isEditMarried ? editFormData.usiaPernikahan : ""}
                    onChange={handleEditFormChange}
                    disabled={!isEditMarried}
                    required={isEditMarried}
                    >
                        <option value="">
                          {isEditMarried ? "Pilih" : "Tidak diperlukan"}
                        </option>
                    {isEditMarried && usiaPernikahanOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                    </Input>
                  
                </FormGroup>
              </Col>
              
              <Col md={6}>
                 <FormGroup>
            <Label for="editStatusKepemilikanTanah">Status Kepemilikan Tanah</Label>
            <Input
              type="select"
              name="StatusKepemilikanTanah"
              id="editStatusKepemilikanTanah"
              value={editFormData.StatusKepemilikanTanah}
              onChange={handleEditFormChange}
              required
            >
              <option value="">Pilih Status</option>
              {statusKepemilikanTanahOptions.map(option => (
                <option key={option} value={option}>{option}</option>
              ))}
              <option value="Lainnya">Lainnya (tulis manual)</option>
            </Input>
          </FormGroup>
          
          {/* Input manual jika dipilih "Lainnya" */}
          {editFormData.StatusKepemilikanTanah === "Lainnya" && (
            <FormGroup>
              <Label for="editStatusKepemilikanTanahLainnya" className="text-primary">
                * Tulis Status Kepemilikan Tanah
              </Label>
              <Input
                type="text"
                name="StatusKepemilikanTanahLainnya"
                id="editStatusKepemilikanTanahLainnya"
                value={editFormData.StatusKepemilikanTanahLainnya || ""}
                onChange={handleEditFormChange}
                placeholder="Contoh: Sewa, Hibah, Wakaf, dll."
                required
              />
              <small className="form-text text-muted">
                Tulis status kepemilikan tanah lainnya yang tidak tersedia di opsi di atas
              </small>
            </FormGroup>
          )}
                
                <FormGroup>
                  <Label for="editApakahLokasiTanahSesuaiRTRW">Lokasi Sesuai RTRW</Label>
                  <Input
                    type="select"
                    name="apakahLokasiTanahSesuaiRTRW"
                    id="editApakahLokasiTanahSesuaiRTRW"
                    value={editFormData.apakahLokasiTanahSesuaiRTRW}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Status</option>
                    {apakahLokasiTanahSesuaiRTRWOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editTingkatPenghasilanKeluarga">Tingkat Penghasilan Keluarga</Label>
                  <Input
                    type="select"
                    name="tingkatPenghasilanKeluarga"
                    id="editTingkatPenghasilanKeluarga"
                    value={editFormData.tingkatPenghasilanKeluarga}
                    onChange={handleEditFormChange}
                    required
                  >
                    <option value="">Pilih Tingkat Penghasilan</option>
                    {tingkatPenghasilanKeluargaOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Input>
                </FormGroup>
                
                <FormGroup>
                  <Label for="editJumlahPenghuniRumah">Jumlah Penghuni Rumah</Label>
                  <Input
                    type="number"
                    name="jumlahPenghuniRumah"
                    id="editJumlahPenghuniRumah"
                    value={editFormData.jumlahPenghuniRumah}
                    onChange={handleEditFormChange}
                    min="1"
                    required
                  />
                </FormGroup>
                
                <FormGroup>
                  <Label for="editStatusVerifikasi">Status Validasi</Label>
                  <Input
                    type="select"
                    name="statusVerifikasi"
                    id="editStatusVerifikasi"
                    value={editFormData.statusVerifikasi}
                    onChange={handleEditFormChange}
                   // required
                  >
                    <option value="">Pilih Status</option>
                    {statusVerifikasiEditOptions.map(option => (
                      <option key={option} value={option}>{option}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup>
            <Label for="editTanggalVerifikasi">
              Tanggal Verifikasi <span className="text-danger">*</span>
            </Label>
            <Input
              type="date"
              name="tanggalVerifikasi"
              id="editTanggalVerifikasi"
              value={editFormData.tanggalVerifikasi}
              onChange={handleEditFormChange}
              max={new Date().toISOString().split('T')[0]}
              required
            />
           
          </FormGroup>
          
          {/* File Upload Section */}
          <hr className="my-3" />
          <h6 className="mb-3">Upload Foto (Opsional)</h6>
          
          <FormGroup>
            <Label for="editFotoKK">Foto Kartu Keluarga</Label>
            {selectedItem?.fotoKK && renderFilePreview(selectedItem.fotoKK, 'Foto KK')}
            <Input
              type="file"
              name="fotoKK"
              id="editFotoKK"
              accept="image/*,.pdf"
              onChange={handleEditFileChange}
            />
            {editFileUploads.fotoKK && <small className="text-success"><i className="fas fa-check me-1"></i>File baru dipilih: {editFileUploads.fotoKK.name}</small>}
          </FormGroup>

          <FormGroup>
            <Label for="editFotoRumah">Foto Rumah</Label>
            {selectedItem?.foto && renderFilePreview(selectedItem.foto, 'Foto Rumah')}
            <Input
              type="file"
              name="fotoRumah"
              id="editFotoRumah"
              accept="image/*,.pdf"
              onChange={handleEditFileChange}
            />
            {editFileUploads.fotoRumah && <small className="text-success"><i className="fas fa-check me-1"></i>File baru dipilih: {editFileUploads.fotoRumah.name}</small>}
          </FormGroup>

          {isEditMilikSendiri && (
          <FormGroup>
            <Label for="editFotoSuratKepemilikanTanah" className="text-danger">
              * Foto Surat Kepemilikan Tanah (Wajib)
            </Label>
            {selectedItem?.fotoSuratKepemilikanTanah && renderFilePreview(selectedItem.fotoSuratKepemilikanTanah, 'Foto Surat Kepemilikan Tanah')}
            <Input
              type="file"
              name="fotoSuratKepemilikanTanah"
              id="editFotoSuratKepemilikanTanah"
              accept="image/*,.pdf"
              onChange={handleEditFileChange}
            />
            {editFileUploads.fotoSuratKepemilikanTanah && <small className="text-success"><i className="fas fa-check me-1"></i>File baru dipilih: {editFileUploads.fotoSuratKepemilikanTanah.name}</small>}
          </FormGroup>
          )}

          <FormGroup>
            <Label for="editFotoRumahSaatIni">Foto Rumah Saat Ini</Label>
            {selectedItem?.fotoRumahSaatIni && renderFilePreview(selectedItem.fotoRumahSaatIni, 'Foto Rumah Saat Ini')}
            <Input
              type="file"
              name="fotoRumahSaatIni"
              id="editFotoRumahSaatIni"
              accept="image/*,.pdf"
              onChange={handleEditFileChange}
            />
            {editFileUploads.fotoRumahSaatIni && <small className="text-success"><i className="fas fa-check me-1"></i>File baru dipilih: {editFileUploads.fotoRumahSaatIni.name}</small>}
          </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              Simpan Perubahan
            </Button>
            <Button color="secondary" onClick={() => setIsEditModalOpen(false)}>
              Batal
            </Button>
          </ModalFooter>
        </Form>
      </Modal>

      {/* Verification Confirmation Modal */}
      <Modal isOpen={isVerificationModalOpen} toggle={() => setIsVerificationModalOpen(false)}>
        <ModalHeader toggle={() => setIsVerificationModalOpen(false)}>
          Konfirmasi Verifikasi Bantuan
        </ModalHeader>
        <ModalBody>
          <div className="alert alert-info">
            <h6>Detail Verifikasi:</h6>
            <p><strong>Nama:</strong> {selectedItem?.namaKepalaKeluarga}</p>
            <p><strong>NIK:</strong> {selectedItem?.nik}</p>
            <p><strong>Alamat:</strong> {selectedItem?.alamat}</p>
            <p><strong>Kategori Saat Ini:</strong> 
              <Badge color={getCategoryBadgeColor(selectedItem?.kategori)} className="ms-1">
                {selectedItem?.kategori}
              </Badge>
            </p>
          </div>
          <p>
            Apakah Anda yakin ingin memverifikasi bahwa keluarga ini <strong>sudah mendapat bantuan</strong>?
          </p>
          <p className="text-muted">
            <small>
              * Tindakan ini akan mengubah status verifikasi bantuan menjadi "Sudah Dapat Bantuan" 
              dan mengubah kategori menjadi "Bisa Dapat Bantuan".
            </small>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={verifikasiBantuan}>
            Ya, Verifikasi
          </Button>
          <Button color="secondary" onClick={() => setIsVerificationModalOpen(false)}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(false)}>
        <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>
          Konfirmasi Hapus
        </ModalHeader>
        <ModalBody>
          <div className="alert alert-warning">
            <h6>Peringatan!</h6>
            <p>Anda akan menghapus data verifikasi untuk:</p>
            <p><strong>Nama:</strong> {selectedItem?.namaKepalaKeluarga}</p>
            <p><strong>NIK:</strong> {selectedItem?.nik}</p>
            <p><strong>Alamat:</strong> {selectedItem?.alamat}</p>
          </div>
          <p>Data yang dihapus tidak dapat dikembalikan. Apakah Anda yakin?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Ya, Hapus
          </Button>
          <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>
            Batal
          </Button>
        </ModalFooter>
      </Modal>

      {/* Map Modal */}
      <Modal isOpen={isMapModalOpen} toggle={() => setIsMapModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setIsMapModalOpen(false)}>
          Lokasi - {selectedItem?.namaKepalaKeluarga}
        </ModalHeader>
        <ModalBody>
          {selectedItem && (
            <div style={{ height: "400px" }}>
              <MapContainer
                center={mapCenter}
                zoom={mapZoom}
                style={{ height: "100%", width: "100%" }}
              >
                <TileLayer
                           url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                           attribution='&copy; <a href="https://www.esri.com/">Esri</a>'
                         />
                <Marker position={mapCenter}>
                  <Popup>
                    <strong>{selectedItem.namaKepalaKeluarga}</strong><br />
                    {selectedItem.alamat}<br />
                    {selectedItem.kecamatan}, {selectedItem.desaKelurahan}
                  </Popup>
                </Marker>
              </MapContainer>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsMapModalOpen(false)}>
            Tutup
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default RekapVerifikasi;